import Connector11FBlue11CBlack from "../components/connectors/Connector11FBlue11CBlack";
import Connector12BBlue12CRed12DRed from "../components/connectors/Connector12BBlue12CRed12DRed";
import Connector12CRed12DRed from "../components/connectors/Connector12CRed12DRed";
import Connector8BRed8DBlue8CRed from "../components/connectors/Connector8BRed8DBlue8CRed";
import Connector8CRed8DBlue from "../components/connectors/Connector8CRed8DBlue";
import Connector5KBlue5CRed from "../components/connectors/Connector5KBlue5CRed";
import Connector5GRed5HBlack5KBlue from "../components/connectors/removeCandidates/Connector5GRed5HBlack5KBlue";
import Connector2BRed2CBlue from "../components/connectors/Connector2BRed2CBlue";
import Connector1CBlue1ARed from "../components/connectors/removeCandidates/Connector1CBlue1ARed";
import Connector16CBlack16ARed from "../components/connectors/Connector16CBlack16ARed";
import Connector16CBlack16BBlack16ARed from "../components/connectors/Connector16CBlack16BBlack16ARed";
import Connector14BBlue14ABlue from "../components/connectors/Connector14BBlue14ABlue";
import Connector5KBlue5GRed5FBlack from "../components/connectors/removeCandidates/Connector5KBlue5GRed5FBlack";
import Connector13ARed13CRed from "../components/connectors/Connector13ARed13CRed";
import Connector13ARed13BRed from "../components/connectors/Connector13ARed13BRed";
import Connector9ABlue13BRed from "../components/connectors/Connector9ABlue13BRed";
import Connector9ABlue13CRed from "../components/connectors/Connector9ABlue13CRed";
import Connector11CBlack11BBlack from "../components/connectors/Connector11CBlack11BBlack";
import Connector11ARed11BBlack from "../components/connectors/Connector11ARed11BBlack";
import Connector16CBlack16DBlack from "../components/connectors/Connector16CBlack16DBlack";
import Connector1EBlue from "../components/connectors/Connector1EBlue";
import Connector1CRed from "../components/connectors/Connector1CRed";

export const connectorsData = {
	'Track1CBlue': {
		component: Connector1CBlue1ARed,
		dependsOn: ['1CBlue', '1ARed']
	},
	// 'Track2BRed': {
	//    component: Connector2BRed2CBlue,
	//    dependsOn: ['2BRed', '2CBlue']
	// },
	'Track1EBlue': {
		component: Connector1EBlue,
		dependsOn: ['1CBlue', '1EBlue']
	},
	'Track1ARed': {
		component: Connector1CRed,
		dependsOn: ['1CBlue', '1EBlue']
	},
	'Track5GRed': {
		component: Connector5GRed5HBlack5KBlue,
		dependsOn: ['5GRed', '5KBlue']
	},
	'Track16BBlack': {
		component: Connector16CBlack16BBlack16ARed,
		dependsOn: ['16ARed', '16BBlack']
	},
	'Track5KBlue': {
		component: Connector5KBlue5CRed,
		dependsOn: ['5KBlue', '5CRed']
	},
	'Track8CRed': {
		component: Connector8CRed8DBlue,
		dependsOn: ['8CRed', '8DBlue']
	},
	'Track8BRed': {
		component: Connector8BRed8DBlue8CRed,
		dependsOn: ['8CRed', '8DBlue', '8BRed']
	},
	'Track12CRed': {
		component: Connector12CRed12DRed,
		dependsOn: ['12CRed', '12DRed']
	},
	'Track12BBlue': {
		component: Connector12BBlue12CRed12DRed,
		dependsOn: ['12BBlue', '12CRed', '12DRed']
	},
	'Track11ARed': {
		component: Connector11ARed11BBlack,
		dependsOn: ['11ARed', '11BBlack']
	},
	'Track11FBlue': {
		component: Connector11FBlue11CBlack,
		dependsOn: ['11FBlue', '11CBlack']
	},
	'Track16CBlack': {
		component: Connector16CBlack16ARed,
		dependsOn: ['16CBlack', '16ARed', '16BBlack']
	},
	'Track16DBlack': {
		component: Connector16CBlack16DBlack,
		dependsOn: ['16DBlack', '16CBlack']
	},
	'Track14BBlue': {
		component: Connector14BBlue14ABlue,
		dependsOn: ['14BBlue', '14ABlue']
	},
	// 'Track5EBlack': {
	// 	component: Connector5KBlue5GRed5FBlack,
	// 	dependsOn: ['5KBlue', '5GRed', '5FBlack']
	// },
	'Track13CRed': {
		component: Connector13ARed13CRed,
		dependsOn: ['13ARed', '13CRed', '13BRed']
	},
	'Track13BRed': {
		component: Connector13ARed13BRed,
		dependsOn: ['13ARed', '13BRed']
	},
	'Track9ABlue': {
		component: Connector9ABlue13BRed,
		dependsOn: ['9ABlue', '13BRed', '13CRed']
	},
	'Track13DRed': {
		component: Connector9ABlue13CRed,
		dependsOn: ['9ABlue', '13CRed']
	},
	'Track11CBlack': {
		component: Connector11CBlack11BBlack,
		dependsOn: ['11CBlack', '11BBlack', '11FBlue']
	}

};

